import { grey } from "./colors/index.js";
const greyOption = (mode)=>'light' === mode ? {
        50: grey["50"],
        100: grey["100"],
        200: grey["200"],
        300: grey["300"],
        400: grey["400"],
        500: grey["500"],
        600: grey["600"],
        700: grey["700"],
        800: grey["800"],
        900: grey["900"],
        950: grey["950"]
    } : {
        50: grey["950"],
        100: grey["900"],
        200: grey["800"],
        300: grey["700"],
        400: grey["600"],
        500: grey["500"],
        600: grey["400"],
        700: grey["300"],
        800: grey["200"],
        900: grey["100"],
        950: grey["50"]
    };
export { greyOption };

//# sourceMappingURL=grey.js.map